import { addDoc, collection } from 'firebase/firestore';
import { db } from '../firebase/config';
import { COLLECTION_META, caregiverName } from './activityUtils';

/** Write a best-effort activity feed entry — never throws. */
async function writeActivity(collectionName, entry, childId, user, profile) {
  const meta = COLLECTION_META[collectionName];
  if (!meta) return;
  try {
    await addDoc(collection(db, 'activityFeed'), {
      childId,
      collectionName,
      icon:      meta.icon,
      label:     meta.label,
      summary:   meta.getSummary(entry),
      eventTime: entry.date,
      loggedAt:  entry.createdAt,
      loggedBy: {
        uid:   user.uid,
        name:  profile?.displayName || caregiverName(user),
        role:  profile?.role        || '',
        email: user.email           || '',
      },
    });
  } catch (err) {
    console.warn('quickLog: activity feed write failed', err);
  }
}

// ── Diaper ────────────────────────────────────────────────────────────────────

export async function quickLogDiaper(type, childId, user, profile = null) {
  const now = new Date().toISOString();
  const entry = {
    childId,
    userId:    user.uid,
    type,
    date:      now,
    notes:     '',
    createdAt: now,
  };
  await addDoc(collection(db, 'diapers'), entry);
  await writeActivity('diapers', entry, childId, user, profile);
}

// ── Bottle ────────────────────────────────────────────────────────────────────

const bottleKey = (childId) => `quicklog_bottleOz_${childId}`;

export function getLastBottleOz(childId) {
  if (!childId) return 4;
  const stored = localStorage.getItem(bottleKey(childId));
  return stored ? parseFloat(stored) : 4;
}

function saveLastBottleOz(childId, oz) {
  if (!childId) return;
  localStorage.setItem(bottleKey(childId), String(oz));
}

export async function quickLogBottle(oz, childId, user, profile = null) {
  const now = new Date().toISOString();
  const entry = {
    childId,
    userId:    user.uid,
    amount:    String(oz),
    type:      'formula',
    date:      now,
    notes:     '',
    createdAt: now,
  };
  await addDoc(collection(db, 'bottleFeeds'), entry);
  saveLastBottleOz(childId, oz);
  await writeActivity('bottleFeeds', entry, childId, user, profile);
}
